import { styled } from '@linaria/react';

import { ButtonIconGhost } from '~shared/ui/atoms/Buttons/ButtonGhost/Icon';
import { MqTablet } from '~theme/media';

export const StyledButton = styled(ButtonIconGhost)`
	&& {
		${MqTablet} {
			display: none;
		}
	}
`;
